<div id="footer">
  <dashboard-svg id="dashboard" (click)="goTo(NAVEGATION.HOME)" [active]="location==NAVEGATION.HOME" ></dashboard-svg>
  <price-board-svg id="tablero-precios" (click)="goTo(NAVEGATION.PRICE_BOARD)" [active]="location==NAVEGATION.PRICE_BOARD"></price-board-svg>
  <order-list-svg id="orden-venta" (click)="goTo(NAVEGATION.ORDER_BOARD)" [active]="location==NAVEGATION.ORDER_BOARD"></order-list-svg>
  <control-panel-svg id="panel-control" (click)="goTo(NAVEGATION.CONTROL_PANEL)" [active]="location==NAVEGATION.CONTROL_PANEL" 
  *ngIf="!isComercial"></control-panel-svg>
  <exchange-order-svg id="exchange-order" (click)="goTo(NAVEGATION.ORDER_EXCHANGE)" [active]="location==NAVEGATION.ORDER_EXCHANGE" 
  *ngIf="isComercial"></exchange-order-svg>  
</div>